import { useContext } from 'react';
import { useTranslations } from '@allie/mfe';
import { translations } from '../helpers/translations';
import { AuthContext } from '../context';
import { getLang } from '../helpers';

export const useAppTranslations = (lang = 'ES') => {
  const { loggedUser } = useContext(AuthContext);

  return useTranslations(translations, getLang(loggedUser, lang));
};
